import React from 'react';
import { CODE_CATEGORIES } from '../../constants/api';
import { useApiAutocomplete } from '../../hooks/useApiAutocomplete';
import { application } from '../../services/application';
import { formatToTitleCase } from '../../utils/helpers';
import Autocomplete from '../common/Inputs/Autocomplete';

export const NaicsCodeAutocomplete = (props) => {
  const { onChange, value, multi, labelKey = 'value', label, ...rest } = props;

  const { options, loading, handleValueChange, filterOptions, handleInputChange } = useApiAutocomplete({
    labelKey,
    onChange: React.useCallback((val) => onChange && onChange(val), [onChange]),
    getOptionList: (params) => application.call(CODE_CATEGORIES.GET_LIST_NAICS_AUTOCOMPLETE, params),
  });

  const validateValueArray = () => {
    if (!multi) return value;
    if (Array.isArray(value)) {
      return value;
    } else {
      return [];
    }
  };

  return (
    <Autocomplete
      name="naics-code"
      options={options}
      label={label}
      labelKey={labelKey}
      loading={loading}
      value={validateValueArray()}
      filterOptions={filterOptions}
      onChange={handleValueChange}
      multiple={multi}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      freeSolo
      formatLabelCB={formatToTitleCase}
      onInputChange={handleInputChange}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      getOptionSelected={(option, value) => option?.id === value?.id}
      {...rest}
    />
  );
};
